<template>
  <div id="app">
    <Header/>
    <el-container>
      <div v-if="isLogin">
        <TopNav/>
      </div>
      <el-main>
        <router-view :key="$route.fullPath"/>
      </el-main>
    </el-container>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer'
import TopNav from '@/components/TopNav.vue'
export default {
	name: 'App',
	components: {
    Header,
    Footer,
    TopNav
  },
  computed: {
    isLogin() {
      if (this.$route.name == 'login' || this.$route.name == 'forgotpassword' || this.$route.name == 'resetpassword'
          || this.$route.name == 'cusipagreement' || this.$route.name == 'qr' || this.$route.name == 'softtoken'){
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    var pjson = require('../package.json');
    console.log("packagejson.version");
    console.log(pjson.version);
  }
}
</script>

<style>
  html, body {
    margin: 0;
    height: 100%;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    min-width: 1210px;
    /* min-height: 800px; */
    /* font-family: 'Open Sans', sans-serif; */
  }

  #app {
    height: 100%;
    background-color: #FAFAFA;
  }

  .el-container {
    height: 100%;
  }

  .el-main {
    color: #44475C;
    padding: 10px !important;
    margin-top: 130px;
    margin-bottom: 58px;
    margin-left: 10px;
    margin-right: 10px;
    z-index: 0;
	}

  .el-message{
    white-space: pre-line !important
  }

</style>
